import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Services from '../components/Services';
import About from '../components/About';
import Projects from '../components/Projects';
import Process from '../components/Process';
import WhyUs from '../components/WhyUs';
import ImageShowcase from '../components/ImageShowcase';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import { useCmsContent } from '../lib/useCmsContent';

export default function HomePage() {
  const { content } = useCmsContent();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== '/') return;
    if (location.hash && location.hash.length > 1) {
      const id = location.hash.slice(1);
      const timer = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 80);
      return () => clearTimeout(timer);
    }
    window.scrollTo({ top: 0, behavior: 'auto' });
    return undefined;
  }, [location.pathname, location.hash, location.key]);

  return (
    <>
      <Helmet>
        <title>{content.seo.title}</title>
        {content.seo.description ? <meta name="description" content={content.seo.description} /> : null}
        {content.seo.ogImageUrl ? <meta property="og:image" content={content.seo.ogImageUrl} /> : null}
      </Helmet>

      <Navbar siteName={content.siteSettings.siteName} />
      <main>
        <Hero hero={content.hero} />
        <Services section={content.servicesSection} />
        <About section={content.aboutSection} />
        <Projects section={content.projectsSection} />
        <Process />
        <WhyUs />
        <ImageShowcase section={content.gallerySection} />
        <Contact siteSettings={content.siteSettings} />
      </main>
      <Footer siteSettings={content.siteSettings} footer={content.footer} />
    </>
  );
}
